import { render, staticRenderFns } from "./TheTraining.vue?vue&type=template&id=7cd5e8f4&"
import script from "./TheTraining.vue?vue&type=script&lang=js&"
export * from "./TheTraining.vue?vue&type=script&lang=js&"
import style0 from "./TheTraining.vue?vue&type=style&index=0&id=7cd5e8f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports